// removed by extract-text-webpack-plugin
module.exports = {"ticketingBanner":"_1cUwoAX8rRQ9HLYqK6sLKp"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/TicketingUrl.scss
// module id = 1455
// module chunks = 0